export default __webpack_public_path__ + "static/Banner_reciclare_1920x800-63fafb2157f9649145fb47f64ea61ec6.jpg";